import React, { useState } from 'react';
import Tutorials from './Tutorials';
import { Search } from 'lucide-react';
import '../../_css/Faqs.css';
import FrequentlyAsked from './FrequentlyAsked';
import AccountSettingsPage from './ManagingAccountSetting';

const Index = () => {
    const [activeTab, setActiveTab] = useState('faq');
    const [searchTerm, setSearchTerm] = useState('');

    // const handleToggle = (tab) => setActiveTab(tab);
    const handleToggle = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };
    const handleSearch = (e) => setSearchTerm(e.target.value);


    return (
        <div className="faqs-container">
            <div className="faqs-header">
                <div className="toggle-switch">
                    <button
                        className={`toggle-btn ${activeTab === 'faq' ? 'active' : ''}`}
                        onClick={() => handleToggle('faq')}
                    >
                        FAQ
                    </button>
                    <button
                        className={`toggle-btn ${activeTab === 'tutorials' ? 'active' : ''}`}
                        onClick={() => handleToggle('tutorials')}
                    >
                        Tutorials
                    </button>
                </div>
                <div className="search-bar">
                    <Search className="search-icon" />
                    <input
                        type="text"
                        placeholder="Search here"
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                </div>

            </div>

            <div>
                {activeTab === 'faq' ? (
                    <FrequentlyAsked searchTerm={searchTerm} />
                ) : (
                    <Tutorials searchTerm={searchTerm} />
                    // <AccountSettingsPage />
                )}
            </div>
        </div>
    );
};

export default Index;
